import React from 'react';

const MobileLogo = () => {
    return (
        <img src={require('../../../assets/mtrading_mobile.png')} width={28} height={22} draggable={false} style={{margin:'0',padding: '0'}}/>
    );
};

export default MobileLogo;